import React from "react";

const TermsAndPolicy = () => {
    return (<>
        Terms and Policy Put here...
    </>)
}
export default TermsAndPolicy;
